// extracted by mini-css-extract-plugin
export default {"scrollIndicator":"ScrollIndicator_scrollIndicator__vRfJ8","scrollIndicatorLine":"ScrollIndicator_scrollIndicatorLine__IBeTW"};